const body = document.getElementsByTagName('body')[0];
const MOBILE_BREAKPOINT = 650;

class SearchSelectInput {
  constructor() {
    this.allowedColors = [
      "rgb(125, 142, 159, 0.90)",
      "rgb(159, 125, 125, 0.90)",
      "rgb(119, 111, 90, 0.90)",
      "rgb(125, 159, 156, 0.90)",
    ];

    this.assignEventsGlobal();

    this.currentSelector = null;
    this.countSelectsHidden = 0;
    this.selects = document.querySelectorAll(
      ".boost-sd__filter-option-title, .boost-sd__sorting-button"
    );
    
    this.overlay = this.createOverlay();
    this.searchSelectInput();
    this.currentClass = "";

    this.moveSortToAnotherContainer();
    this.assignEventToOpenOverlay();
    this.assignEventToOpenOverlayResponsive();
    this.assignEventToCloseOverlay();
    this.observeParams();

    const bodyElement = document.querySelector("body");
    if (bodyElement) {
      bodyElement.addEventListener("click", (e) => {
        if (
          e.target.classList.contains("overflow-active") ||
          e.target.classList.contains("boost-sd__button--clear")
        ) {
          this.resetClassesOverlay();
        }
      });
    }

    this.changeLabelSorting();
    this.moveSortIntoWrapperSwiper();
    this.updateMobileToolbar();
    this.setupClearButtonVisibility();
    this.setupToolbarClearAll();
    this.setupSortValueVisibility();
    this.setupMobileFilterLimitThree();
    this.setupMobileFilterSelectedListSync();
    this.setupShowResultButtonStates();
  }

  getOverlaySelection() {
    const container = document.querySelector(".boost-sd__filter-tree-vertical-option-list") || document.querySelector(".boost-sd__filter-tree-vertical-content");
    if (!container) return { sort: "", filterCount: 0 };
    const activeSort = container.querySelector(".boost-sd__sorting-option--active, .boost-sd__sorting-option[aria-selected='true']");
    const sort = activeSort ? (activeSort.getAttribute("data-value") || activeSort.getAttribute("value") || "") : "";
    const filterCount = container.querySelectorAll("button[aria-checked='true'], button.boost-sd__filter-option-item-button--selected").length;
    return { sort, filterCount };
  }

  getShowResultButtonState() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return "show-result";
    const saved = this.savedUrlAtOpen;
    if (!saved) return "show-result";
    const { sort: savedSort, filterParamCount: savedFilterCount } = saved;
    const savedHasFiltersOrSort = savedFilterCount > 0 || (savedSort.length > 0 && savedSort !== "manual");
    const { sort: overlaySort, filterCount: overlayFilterCount } = this.getOverlaySelection();
    const overlayEmpty = (overlaySort === "" || overlaySort === "manual") && overlayFilterCount === 0;
    if (!savedHasFiltersOrSort && overlayEmpty) return "apply-disabled";
    if (savedHasFiltersOrSort && savedSort === overlaySort && savedFilterCount === overlayFilterCount) return "clear-all";
    return "show-result";
  }

  updateShowResultButton() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    const wrap = document.querySelector(".boost-sd__filter-tree-vertical-show-result");
    const btn = wrap && wrap.querySelector("button.boost-sd__button--result");
    if (!btn) return;
    const state = this.getShowResultButtonState();
    if (this._lastShowResultState === state) return;
    this._lastShowResultState = state;
    const textEl = btn.querySelector(".boost-sd__button-text");
    btn.setAttribute("data-show-result-state", state);
    if (state === "apply-disabled") {
      btn.setAttribute("disabled", "true");
      btn.classList.add("boost-sd__button--result-disabled");
      if (textEl) textEl.textContent = "APPLY FILTER(S)";
    } else if (state === "clear-all") {
      btn.removeAttribute("disabled");
      btn.classList.remove("boost-sd__button--result-disabled");
      if (textEl) textEl.textContent = "CLEAR ALL";
    } else {
      btn.removeAttribute("disabled");
      btn.classList.remove("boost-sd__button--result-disabled");
    }
  }

  setupShowResultButtonStates() {
    let scheduleTimer = null;
    const run = () => {
      this.updateShowResultButton();
    };
    const scheduleRun = () => {
      if (scheduleTimer) clearTimeout(scheduleTimer);
      scheduleTimer = setTimeout(() => {
        scheduleTimer = null;
        run();
      }, 80);
    };
    const container = document.querySelector(".boost-sd__filter-tree-vertical-option-list") || document.querySelector(".boost-sd__filter-tree-vertical-content");
    if (container) {
      const observer = new MutationObserver(scheduleRun);
      observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "aria-checked", "aria-selected"] });
    }
    document.body.addEventListener("click", (e) => {
      const btn = e.target.closest("button.boost-sd__button--result");
      if (!btn || window.innerWidth >= MOBILE_BREAKPOINT) return;
      const state = btn.getAttribute("data-show-result-state");
      if (state === "apply-disabled") {
        e.preventDefault();
        e.stopPropagation();
      } else if (state === "clear-all") {
        e.preventDefault();
        e.stopPropagation();
        this.clearAllFilters();
      }
    }, true);
  }

  updateSortValueVisibility() {
    if (typeof window === "undefined" || window.innerWidth >= MOBILE_BREAKPOINT) return;
    const sortSection = document.querySelector(".boost-sd__filter-tree-vertical-option-list .boost-sd__sorting, .boost-sd__filter-tree-vertical-content .boost-sd__sorting");
    if (!sortSection) return;
    const valueEl = sortSection.querySelector(".boost-sd__sorting-value");
    const active = sortSection.querySelector("li.boost-sd__sorting-option--active, li.boost-sd__sorting-option[aria-selected='true']");
    const sortVal = active && active.getAttribute("data-value");
    const isManual = !sortVal || sortVal === "manual";
    if (valueEl) {
      if (isManual) {
        valueEl.style.display = "none";
        valueEl.textContent = "";
      } else {
        valueEl.style.display = "";
        valueEl.textContent = active ? active.textContent.trim() : "";
      }
    }
  }

  setupSortValueVisibility() {
    this.updateSortValueVisibility();
    document.body.addEventListener("click", (e) => {
      if (e.target.closest(".boost-sd__sorting-option")) {
        setTimeout(() => this.updateSortValueVisibility(), 150);
      }
    }, true);
  }

  setupMobileFilterLimitThree() {
    const MAX_SELECT_PER_FILTER = 3;
    const MULTI_SELECT_TITLES = /^(categories|brands|size)$/i;
    document.body.addEventListener("click", (e) => {
      const btn = e.target.closest("button.boost-sd__filter-option-item-button");
      if (!btn) return;
      const section = btn.closest(".boost-sd__filter-option");
      if (!section || section.querySelector(".boost-sd__sorting")) return;
      const titleEl = section.querySelector(".boost-sd__filter-option-title");
      const title = (titleEl && titleEl.textContent || "").trim().replace(/\s*:\s*$/, "");
      if (!MULTI_SELECT_TITLES.test(title)) return;
      const selected = section.querySelectorAll("button[aria-checked='true'], button.boost-sd__filter-option-item-button--selected");
      const isAlreadySelected = btn.getAttribute("aria-checked") === "true" || btn.classList.contains("boost-sd__filter-option-item-button--selected");
      if (selected.length >= MAX_SELECT_PER_FILTER && !isAlreadySelected) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  updateMobileFilterSelectedList() {
    if (typeof window === "undefined" || window.innerWidth >= MOBILE_BREAKPOINT) return;
    const container = document.querySelector(".boost-sd__filter-tree-vertical-option-list") || document.querySelector(".boost-sd__filter-tree-vertical-content");
    if (!container) return;
    const escape = (s) => {
      const d = document.createElement("div");
      d.textContent = s;
      return d.innerHTML;
    };
    container.querySelectorAll(".boost-sd__filter-option:not(:has(.boost-sd__sorting))").forEach((section) => {
      const selectedEl = section.querySelector(".boost-sd__filter-option-mobile-items-selected");
      if (!selectedEl) return;
      const selected = section.querySelectorAll("button[aria-checked='true'], button.boost-sd__filter-option-item-button--selected");
      const labels = Array.from(selected).map((b) => {
        const L = b.querySelector(".boost-sd__filter-option-item-label");
        return L ? L.textContent.trim() : "";
      }).filter(Boolean);
      const currentItems = Array.from(selectedEl.querySelectorAll(".boost-sd__filter-option-mobile-item")).map((li) => li.textContent.trim());
      const same = currentItems.length === labels.length && currentItems.every((val, i) => val === labels[i]);
      if (same) return;
      if (labels.length === 0) {
        selectedEl.innerHTML = "";
        return;
      }
      selectedEl.innerHTML = "<ul class=\"boost-sd__filter-option-mobile-list\">" + labels.map((l) => "<li class=\"boost-sd__filter-option-mobile-item\">" + escape(l) + "</li>").join("") + "</ul>";
    });
  }

  setupMobileFilterSelectedListSync() {
    const container = document.querySelector(".boost-sd__filter-tree-vertical-option-list") || document.querySelector(".boost-sd__filter-tree-vertical-content");
    if (!container) return;
    let timeout = null;
    const schedule = (mutations) => {
      const onlyOurList = mutations && mutations.length > 0 && mutations.every((m) => {
        const el = m.target;
        return el.nodeType === 1 && (el.classList.contains("boost-sd__filter-option-mobile-items-selected") || el.closest(".boost-sd__filter-option-mobile-items-selected"));
      });
      if (onlyOurList) return;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        this.updateMobileFilterSelectedList();
      }, 100);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "aria-checked"] });
  }

  moveSortIntoWrapperSwiper() {
    if (window.innerWidth > MOBILE_BREAKPOINT) return null;

    const sortingElement = document.querySelector(".boost-sd__sorting");
    const filterOptionList = document.querySelector(
      ".boost-sd__filter-tree-vertical-option-list"
    );

    if (!sortingElement || !filterOptionList) return null;

    filterOptionList.appendChild(sortingElement);
    sortingElement.classList.add("boost-sd__sorting--mobile");

    const button = sortingElement.querySelector(".boost-sd__sorting-button");
    if (button) {
      button.addEventListener("click", () => {
        button.classList.toggle("boost-sd__sorting-button--active");
      });
    }
  }

  changeLabelSorting() {
    const sortingLabel = document.querySelector(
      ".boost-sd__filter-tree-vertical-toolbar-middle"
    );

    const sortingLabelTitle = document.querySelector(
      "span.boost-sd__filter-tree-toggle-button-title"
    );
    
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      if (sortingLabel) {
        sortingLabel.innerHTML = "SORT BY";
      }
      if (sortingLabelTitle) {
        sortingLabelTitle.innerHTML = "SORT BY";
      }
    }

    if(sortingLabelTitle){
      const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svgElement.setAttribute('width', '16');
      svgElement.setAttribute('height', '10');
      svgElement.setAttribute('viewBox', '0 0 16 10');
      svgElement.setAttribute('fill', 'none');

      svgElement.innerHTML = `
        <path d="M0.961047 2.11628C1.01503 2.30573 1.1168 2.47851 1.25674 2.6181C3.2824 4.64376 5.30841 6.66839 7.33475 8.69216L7.35195 8.70987C7.3743 8.73394 7.39286 8.75285 7.41212 8.77056C7.59297 8.93662 7.82591 9.02017 8.06831 9.01089C8.31226 9.00058 8.53695 8.89605 8.70164 8.71657L8.71901 8.69818C10.7495 6.66581 12.7757 4.64067 14.803 2.61707C15.0245 2.40527 15.1352 2.11955 15.1123 1.82781C15.059 1.32015 14.5973 0.942972 14.0805 0.997297C13.8682 1.02652 13.6473 1.14033 13.4857 1.30829C11.8953 2.90073 10.3142 4.48268 8.73241 6.06463L8.68858 6.10709C8.61654 6.19529 8.52904 6.2668 8.42796 6.32027C8.07759 6.51058 7.62632 6.41963 7.36965 6.10881L7.32839 6.06859C5.73699 4.47426 4.1485 2.88611 2.55864 1.29969C2.21413 0.93025 1.69306 0.883662 1.31124 1.18021C1.13898 1.31396 1.01486 1.50221 0.958984 1.7128L0.961047 2.11628Z" fill="#ADADAD"/>
      `;

      sortingLabelTitle.insertAdjacentElement('afterend', svgElement);
    }
  }

  updateMobileToolbar() {
    const toolbar = document.querySelector(".boost-sd__filter-tree-vertical-mobile-toolbar");
    if (!toolbar) return;

    const closeButton = toolbar.querySelector("button.boost-sd__button--close");
    if (closeButton) {
      closeButton.querySelectorAll("svg").forEach((el) => el.remove());
      let wrapper = closeButton.querySelector(".boost-sd__button-text");
      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.className = "boost-sd__button-text";
        closeButton.appendChild(wrapper);
      }
      wrapper.textContent = "BACK";
      closeButton.classList.add("boost-sd__button--back-label");
      closeButton.setAttribute("aria-label", "Back");
      if (!closeButton.hasAttribute("aria-labelledby")) {
        closeButton.setAttribute("aria-labelledby", "Close");
      }
    }

    const clearButtons = toolbar.querySelectorAll("button.boost-sd__button--clear");
    let clearButton = clearButtons[0] || null;
    for (let i = 1; i < clearButtons.length; i++) {
      clearButtons[i].remove();
    }
    if (!clearButton) {
      clearButton = document.createElement("button");
      clearButton.type = "button";
      clearButton.className = "boost-sd__button boost-sd__button--clear";
      const clearButtonText = document.createElement("div");
      clearButtonText.className = "boost-sd__button-text";
      clearButtonText.textContent = "Clear All";
      clearButton.appendChild(clearButtonText);
      toolbar.appendChild(clearButton);
    }
    if (clearButton && !clearButton.hasAttribute("data-handler-attached")) {
      clearButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.clearAllFilters();
      });
      clearButton.setAttribute("data-handler-attached", "true");
    }
  }

  hasActiveFilters() {
    // Check URL parameters for filter-related params
    const urlParams = new URLSearchParams(window.location.search);
    const filterParams = Array.from(urlParams.keys()).filter(key =>
      key !== 'q' && key !== 'sort_by' && key !== 'sort' && key !== 'page'
    );
    
    // Also check for active filter elements in the DOM
    const activeFilters = document.querySelectorAll(
      ".boost-sd__filter-option-item-button--selected, " +
      ".boost-sd__sorting-option--active, " +
      "[class*='boost-sd__filter'][class*='active'], " +
      ".boost-sd__filter-option-item-button[aria-checked='true']"
    );

    return filterParams.length > 0 || activeFilters.length > 0;
  }

  hasActiveSort() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortVal = urlParams.get("sort") || urlParams.get("sort_by") || "";
    return sortVal.length > 0 && sortVal !== "manual";
  }

  hasFiltersOrSort() {
    return this.hasActiveFilters() || this.hasActiveSort();
  }

  /** URL only: true when there are filter params or a non-manual sort (for toolbar CLEAR ALL visibility) */
  hasFiltersOrSortFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const filterKeys = Array.from(urlParams.keys()).filter(
      (key) => key !== "q" && key !== "sort_by" && key !== "sort" && key !== "page"
    );
    const sortVal = urlParams.get("sort") || urlParams.get("sort_by") || "";
    const hasSort = sortVal.length > 0 && sortVal !== "manual";
    return filterKeys.length > 0 || hasSort;
  }

  clearAllFilters() {
    // Store the current overlay background color before clearing
    const currentBgColor = this.overlay ? this.overlay.style.backgroundColor : null;
    
    // Don't reset overlay immediately - wait for boost container to hide
    // Only remove body scroll lock
    if (body) {
      body.classList.remove("not-scroll");
    }

    // Try to find and click Boost's clear button (inside filter content, not our mobile toolbar)
    const toolbar = document.querySelector(".boost-sd__filter-tree-vertical-mobile-toolbar");
    const boostClearButtons = document.querySelectorAll("button.boost-sd__button.boost-sd__button--clear");
    let boostClearButton = null;
    boostClearButtons.forEach((btn) => {
      if (!toolbar || !toolbar.contains(btn)) {
        boostClearButton = btn;
      }
    });

    if (boostClearButton) {
      boostClearButton.click();
      // Watch for boost container to hide, then reset overlay
      this.waitForBoostContainerHide(currentBgColor);
      return;
    }

    // Fallback: Clear filter/sort URL params and reload (keep q for search)
    const url = new URL(window.location.href);
    const paramsToKeep = ['q'];
    const newParams = new URLSearchParams();
    paramsToKeep.forEach((key) => {
      if (url.searchParams.has(key)) {
        newParams.set(key, url.searchParams.get(key));
      }
    });
    const newUrl = url.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
    window.location.href = newUrl;
  }

  waitForBoostContainerHide(savedBgColor, onComplete) {
    if (!this.overlay) return;
    
    // Preserve the background color
    if (savedBgColor) {
      this.overlay.style.backgroundColor = savedBgColor;
    }

    // Watch for boost container to be hidden/removed
    const boostContainer = document.querySelector(".boost-sd__filter-tree-vertical-sticky-overlay") ||
                          document.querySelector(".boost-sd__filter-tree-vertical") ||
                          document.querySelector("[class*='boost-sd__filter-tree']");
    
    if (!boostContainer) {
      // Container doesn't exist, reset overlay immediately
      this.resetClassesOverlay();
      if (onComplete) onComplete();
      return;
    }

    const checkContainer = () => {
      const isHidden = boostContainer.offsetParent === null ||
                      boostContainer.style.display === 'none' ||
                      boostContainer.classList.contains('hidden') ||
                      window.getComputedStyle(boostContainer).display === 'none';
      
      if (isHidden) {
        this.resetClassesOverlay();
        if (onComplete) onComplete();
        return true;
      }
      return false;
    };

    // Check immediately
    if (checkContainer()) return;

    // Watch for changes
    const observer = new MutationObserver(() => {
      if (checkContainer()) {
        observer.disconnect();
      }
    });

    observer.observe(boostContainer, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: false,
      subtree: false
    });

    // Also check periodically
    const intervalId = setInterval(() => {
      if (checkContainer()) {
        clearInterval(intervalId);
        observer.disconnect();
      }
    }, 100);

    // Timeout after 3 seconds
    setTimeout(() => {
      clearInterval(intervalId);
      observer.disconnect();
      this.resetClassesOverlay();
      if (onComplete) onComplete();
    }, 3000);
  }

  setupClearButtonVisibility() {
    const toolbar = document.querySelector(".boost-sd__filter-tree-vertical-mobile-toolbar");
    const clearButton = toolbar ? toolbar.querySelector("button.boost-sd__button--clear") : null;
    const closeButton = toolbar ? toolbar.querySelector("button.boost-sd__button--close") : null;

    const updateVisibility = () => {
      const hasFilters = this.hasActiveFilters();
      const hasFiltersOrSortFromUrl = this.hasFiltersOrSortFromUrl();

      // Update Clear All button visibility
      if (clearButton) {
        if (hasFilters) {
          clearButton.classList.add('show-clear-button');
          clearButton.removeAttribute('hidden');
        } else {
          clearButton.classList.remove('show-clear-button');
          clearButton.setAttribute('hidden', 'true');
        }
      }

      // Update CLEAR ALL row under toolbar-top-mobile: only when URL has filters or non-manual sort (mobile only)
      const toolbarClearRow = document.querySelector(".boost-sd__toolbar-clear-all-row");
      if (toolbarClearRow && window.innerWidth < MOBILE_BREAKPOINT) {
        toolbarClearRow.style.display = hasFiltersOrSortFromUrl ? "" : "none";
      }

      // Update Close button visibility (mobile only)
      if (closeButton && window.innerWidth < MOBILE_BREAKPOINT) {
        if (hasFilters) {
          closeButton.classList.add('show-close-button');
          closeButton.removeAttribute('hidden');
        } else {
          closeButton.classList.remove('show-close-button');
          closeButton.setAttribute('hidden', 'true');
        }
      }
    };

    // Initial check
    updateVisibility();

    // Watch for URL changes
    const urlObserver = () => {
      updateVisibility();
    };
    window.addEventListener('popstate', urlObserver);

    // Watch for DOM changes (filter selections)
    const domObserver = new MutationObserver(() => {
      updateVisibility();
    });

    const filterContainer = document.querySelector(".boost-sd__filter-tree-vertical-content") ||
                             document.querySelector(".boost-sd__filter-tree") ||
                             document.body;

    if (filterContainer) {
      domObserver.observe(filterContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-checked']
      });
    }

    // Ensure toolbar CLEAR ALL row visibility updates on load (toolbar may exist before overlay)
    requestAnimationFrame(() => updateVisibility());

    // Also check periodically in case mutations aren't caught
    const intervalId = setInterval(() => {
      updateVisibility();
    }, 500);

    // Clean up interval after 60 seconds (filters should be stable by then)
    setTimeout(() => {
      clearInterval(intervalId);
    }, 60000);
  }

  setupToolbarClearAll() {
    const tryInject = () => {
      const toolbar = document.querySelector(".boost-sd__toolbar-top-mobile");
      if (!toolbar || document.querySelector(".boost-sd__toolbar-clear-all-row")) return true;
      const row = document.createElement("div");
      row.className = "boost-sd__toolbar-clear-all-row";
      row.style.display = "none";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "boost-sd__toolbar-clear-all-button";
      btn.textContent = "CLEAR ALL";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const url = new URL(window.location.href);
        const paramsToKeep = ["q"];
        const newParams = new URLSearchParams();
        paramsToKeep.forEach((key) => {
          if (url.searchParams.has(key)) newParams.set(key, url.searchParams.get(key));
        });
        const newUrl = url.pathname + (newParams.toString() ? "?" + newParams.toString() : "");
        window.location.href = newUrl;
      });
      row.appendChild(btn);
      toolbar.after(row);
      if (this.hasFiltersOrSortFromUrl() && window.innerWidth < MOBILE_BREAKPOINT) row.style.display = "";
      return true;
    };
    if (!tryInject()) {
      let attempts = 0;
      const t = setInterval(() => {
        if (tryInject() || ++attempts > 40) clearInterval(t);
      }, 250);
    }
  }

  assignEventsGlobal() {
    const sortingLabel = document.querySelector(".boost-sd__sorting-label");
    if (!sortingLabel) return false;
    
    const removeColon = () => {
      if (sortingLabel.textContent.includes(":")) {
        sortingLabel.textContent = sortingLabel.textContent.replace(/:\s*/g, "").trim();
      }
    };

    removeColon();

    const parent = sortingLabel.parentNode.querySelector(
      ".boost-sd__sorting-button"
    );

    const parentMobile = sortingLabel.parentNode.parentNode.querySelector(
      ".boost-sd__sorting--mobile"
    );

    if (!parent || parentMobile) return false;

    parent.appendChild(sortingLabel);

    removeColon();

    const observer = new MutationObserver(() => {
      removeColon();
    });

    observer.observe(sortingLabel, {
      childList: true,
      characterData: true,
      subtree: true
    });

    sortingLabel.addEventListener("click", () => {
      if (window.innerWidth < MOBILE_BREAKPOINT) return null;
      const sortingButton = parent.querySelector(".boost-sd__sorting-value");
      if (sortingButton) {
        sortingButton.click();
      }
    });
  }

  areSearchParamsEqual(params1, params2) {
    const keys1 = Array.from(params1.keys());
    const keys2 = Array.from(params2.keys());

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (params1.getAll(key).join(",") !== params2.getAll(key).join(",")) {
        return false;
      }
    }

    return true;
  }

  observeParams() {
    const handleUrlChange = () => {
      const newSearchParams = new URLSearchParams(window.location.search);
      if (!this.areSearchParamsEqual(this.currentSearchParams, newSearchParams)) {
        const overlay = document.querySelector(".overlay--select") || this.overlay;
        const overlayOpen = overlay && !overlay.classList.contains("hidden");
        if (window.innerWidth < MOBILE_BREAKPOINT && overlayOpen) {
          this.currentSearchParams = newSearchParams;
        } else {
          this.resetClassesOverlay();
          this.currentSearchParams = newSearchParams;
        }
      }
    };
    this.currentSearchParams = new URLSearchParams(window.location.search);
    window.addEventListener("popstate", handleUrlChange);
  }

  assignEventToCloseOverlay() {
    const selectors = document.querySelectorAll(
      ".boost-sd__button--apply, .boost-sd__button--clear, .boost-sd__button--close, button.boost-sd__button.boost-sd__button--result, button.boost-sd__filter-option-title.boost-sd__filter-option-title--opening"
    );
    selectors.forEach((selector) => {
      selector.addEventListener("click", () => {
        this.resetClassesOverlay();
      });
    });
  }

  assignEventToOpenOverlay() {
    const selectors = document.querySelectorAll(
      "button.boost-sd__filter-tree-toggle-button"
    );
    selectors.forEach((selector) => {
      selector.addEventListener("click", () => {
        this.openOverlay();
      });
    });
  }

  assignEventToOpenOverlayResponsive() {
    const clearButton = document.querySelector(
      "button.boost-sd__button.boost-sd__button--clear"
    );
    const closeButton = document.querySelector(
      "button.boost-sd__button.boost-sd__button--close"
    );

    if (!clearButton || !closeButton) return null;

    clearButton.addEventListener("click", () => {
      closeButton.click();
    });
  }

  moveSortToAnotherContainer() {
    const containerLeft = document.querySelector(
      ".boost-sd-left .boost-sd__filter-tree-horizontal-option-list"
    );
    const ElementSort = document.querySelector(
      ".boost-sd__toolbar-item.boost-sd__toolbar-item--sorting"
    );

    if (!ElementSort || !containerLeft) return;

    const sortContainer = document.createElement("div");
    sortContainer.className = "boost-sd-left-sort";
    sortContainer.appendChild(ElementSort);

    containerLeft.appendChild(sortContainer);
  }

  searchSelectInput() {
    this.overlay = document.querySelector(".overlay--select") || this.overlay;
    
    if (this.selects.length > 0 && this.overlay) {
      this.countSelectsHidden = this.selects.length;

      this.selects.forEach((selector) => {
        if (selector.classList.contains("boost-sd__sorting--mobile")) return null;
        
        selector.addEventListener("click", () => {
          this.currentClass = selector.textContent
            .split(" ")[0]
            .replace(":", "")
            .toLowerCase();
          this.toggleOverlayClass(selector);
        });
      });

      this.overlay.addEventListener("click", (e) => {
        if (e.target === this.overlay) this.resetClassesOverlay();
      });
    }
  }

  resetClassesOverlay() {
    this.currentClass = "";
    this._lastShowResultState = null;
    const overlay = document.querySelector(".overlay--select") || this.overlay;
    if (overlay) {
      overlay.className = "overlay--select hidden";
    }
    if (body) {
      body.classList.remove("not-scroll");
    }
  }

  openOverlay() {
    this.overlay = document.querySelector(".overlay--select") || this.overlay;
    if (!this.overlay) return;
    const urlParams = new URLSearchParams(window.location.search);
    this.savedUrlAtOpen = {
      sort: urlParams.get("sort") || urlParams.get("sort_by") || "",
      filterParamCount: Array.from(urlParams.keys()).filter((k) => k !== "q" && k !== "sort_by" && k !== "sort" && k !== "page").length
    };
    this.setOverlayRandomColor();
    this.overlay.classList.remove("hidden");
    if (body) {
      body.classList.add("not-scroll");
    }
    this.updateMobileToolbar();
    setTimeout(() => this.updateMobileToolbar(), 100);
    this.updateSortValueVisibility();
    this.updateMobileFilterSelectedList();
    this.updateShowResultButton();
    setTimeout(() => {
      this.updateSortValueVisibility();
      this.updateMobileFilterSelectedList();
      this.updateShowResultButton();
    }, 150);
  }

  toggleOverlayClass(selector) {
    if (!selector || !selector.parentNode || !selector.parentNode.parentNode) return;

    const parent = selector.parentNode.parentNode;

    const observer = new MutationObserver((mutationsList) => {
      const selectHidden = mutationsList.some((mutation) =>
        mutation.target.classList.contains(
          "boost-sd__filter-option-itemwrapper--hidden"
        )
      );

      const isOptionOpening = mutationsList.some((mutation) =>
        mutation.target.classList.contains(
          "boost-sd__filter-option-title--opening"
        )
      );

      const validationMutation = mutationsList.some((mutation) =>
        mutation.target.classList.contains("boost-sd__sorting-button--active")
      );

      const isSortButton = mutationsList.some((mutation) =>
        mutation.target.classList.contains("boost-sd__sorting-button")
      );

      this.openOverlay();

      if (
        ((!validationMutation && isSortButton) && window.innerWidth > MOBILE_BREAKPOINT) ||
        (!isOptionOpening && selectHidden)
      ) {
        this.resetClassesOverlay();
      }

      const bodyElement = document.querySelector("body");
      if (bodyElement) {
        bodyElement.classList.toggle("overflow-active", this.currentClass !== "");
      }

      observer.disconnect();
    });

    observer.observe(parent, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["class"],
    });
  }

  createOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "overlay--select hidden";
    document.body.appendChild(overlay);
    return overlay;
  }

  setOverlayRandomColor() {
    if (!this.overlay) return;
    const randomColor =
      this.allowedColors[Math.floor(Math.random() * this.allowedColors.length)];
    this.overlay.style.backgroundColor = randomColor;
  }
}

const searchFilterApp = () => {
  const elemento = document.querySelector(".boost-sd__filter-option-title");

  if (elemento) {
    new SearchSelectInput();
    clearInterval(intervalFindElementFilters);
  } else {
    const sortingButton = document.querySelector(".boost-sd__sorting-button");
    if (sortingButton) {
      new SearchSelectInput();
      clearInterval(intervalFindElementFilters);
    }
  }
};

const intervalFindElementFilters = setInterval(searchFilterApp, 25);

setTimeout(() => {
  clearInterval(intervalFindElementFilters);
}, 10000);